import React  from 'react';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import {
    AddIcon,
    IconCanceledByVisitorCard,
    ConnectIcon,
    SettingIcon
} from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import DivContainerBody from '../../../../components/DivContainerBody';
import FieldsController from './FieldsController';
import TimeZoneController from './TimeZoneController';
import UpdateControllerApp from "./Functionality/UpdateControllerApp";
import FormatTable from "./SubComponents/FormatTable";
import InputTable from "./SubComponents/InputTable";
import SiosTable from "./SubComponents/SiosTable";
import ReaderTable from "./SubComponents/ReaderTable";
import {permissionObj} from "../../../../Helpers/permission";
import CommonControllerApp from "./Functionality/CommonControllerApp";
import OutputTable from "./SubComponents/OutputTable";
import AcrTable from "./SubComponents/AcrTable";
import { handleConnect, handleReset, handleSetConfig } from './Model/Models';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const UpdateController = () => {
    const props = CommonControllerApp();

    const {
        controller,
        handleChange,
        emptyFields,
        getListStatus,
        isValidIp,
        isValidOffset
    } = props;

    const {
        DEV,
        permission,
        handleUpdate,
        defaultSioList,
        defaultFormatList,
        dispatch,
        id,
        disabled
    } = UpdateControllerApp(props);

    return (
        <>
            <HeadTittle name={disabled ? 'details' : 'update'} link={routes.controller.list} >
                {!disabled && (
                    <>
                        <ButtonAction
                            id='btn_up_connect'
                            name='connect'
                            className='btn-icon-add'
                            Icon={ConnectIcon}
                            onClick={() => handleConnect(dispatch, id)}
                        />
                        <ButtonAction
                            id='btn_up_set_config'
                            name='set_config'
                            className='btn-icon-reset-config'
                            splitName={false}
                            Icon={SettingIcon}
                            onClick={() => handleSetConfig(dispatch, id)}
                        />
                        <ButtonAction
                            id='btn_up_reset'
                            name={"reset"}
                            className='btn-icon-delete'
                            Icon={IconCanceledByVisitorCard}
                            onClick={() => handleReset(dispatch, id)}
                        />
                    </>
                )}

                {!disabled && (DEV || permission?.includes(permissionObj?.WEB_HID_UPDATE)) && (
                    <ButtonAction
                        id='btn_uc_update'
                        name='update'
                        className='btn-icon-edit'
                        Icon={AddIcon}
                        onClick={() => {
                            handleUpdate();
                        }}
                    />
                )}
            </HeadTittle>
            <DivContainerBody>
                <div className='row mt-4'>
                    <FieldsController
                        controller={controller}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        allStatus={getListStatus}
                        isValidIp={isValidIp}
                        isValidOffset={isValidOffset}
                        disabled={disabled}
                    />
                </div>
                <TimeZoneController
                    controller={controller}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                    disabled={disabled}
                />
                <FormatTable defaultFormatList={defaultFormatList} disabled={disabled}/>
                <SiosTable defaultSioList={defaultSioList} disabled={disabled}/>
                <ReaderTable defaultSioList={defaultSioList} disabled={disabled}/>
                <InputTable defaultSioList={defaultSioList} disabled={disabled}/>
                <OutputTable defaultSioList={defaultSioList} disabled={disabled}/>
                <AcrTable defaultSioList={defaultSioList} disabled={disabled}/>
            </DivContainerBody>
        </>
    );
};

export default UpdateController;
